import axios from 'utils/axios'
import { ICreateWorkspaceValue } from 'components/CreateWorkspace'
import { API_WORKSPACE_BASE_URL } from '../config'

export const getAllUserWorkspaces = (): Promise<any> => axios.get(`${API_WORKSPACE_BASE_URL}/pages`)

export const createWorkspace = (data: ICreateWorkspaceValue): Promise<any> => axios.post(`${API_WORKSPACE_BASE_URL}/pages`, { ...data })